import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditTransferGoods from '../components/addEditTransferGoods.vue';

var CopyTransferGoodsPage = function (_super) {
  __extends(CopyTransferGoodsPage, _super);

  function CopyTransferGoodsPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CopyTransferGoodsPage = __decorate([Component({
    components: {
      AddEditTransferGoods: AddEditTransferGoods
    }
  })], CopyTransferGoodsPage);
  return CopyTransferGoodsPage;
}(Vue);

export default CopyTransferGoodsPage;